import {defineStore} from "pinia";

export const usePortalFilterAndPaginationStore = defineStore('portalFilterAndPaginationStore', {
    state: () => ({
        filters: {},
        sorting: {
            key: 'created_at',
            direction: 'desc'
        },
        searchFieldPlaceholder: 'Search by name or email...',
        search: '',
        layoutOptions: {},
        metaData: {},
        validationErrors: null,
        referralsFiltersAndPaginationData: {},
        leadsFiltersAndPaginationData: {},
        loadingFiltersAndPaginationData: false,
    }),
    actions: {
        async getFiltersAndPaginationData(routeName, filters = {}, dataUrl = null) {
            let url = dataUrl
            if (!url && routeName === 'referrals') {
                url = this.getPartnerProgramActivitiesRoute
            } else if (!url && routeName === 'leads') {
                url = this.getLeadsActivitiesUrl
            }
            this.loadingFiltersAndPaginationData = true
            try {
                const response = await axios.get(url, {params: filters})
                if (routeName === 'referrals') {
                    this.referralsFiltersAndPaginationData = response.data
                }
                if (routeName === 'leads') {
                    this.leadsFiltersAndPaginationData = response.data
                }
            } catch (error) {
                this.validationErrors = error.response?.data?.errors;
            } finally {
                this.loadingFiltersAndPaginationData = false
            }
        },
        setFilters(modelFilters) {
            this.filters = modelFilters
        },
        setSearchFieldPlaceholder(placeholder) {
            this.searchFieldPlaceholder = placeholder
        },
        setSearchParam(searchQuery) {
            this.search = searchQuery
        },
        setMetaData(data) {
            this.metaData = data
        },
        setValidationErrors(errors) {
            this.validationErrors = errors
        },
        setSorting(sorting) {
            this.sorting = sorting
        },
    },
    getters: {
        getPartnerProgramActivitiesRoute() {
            return route('partners_int.views.referrals.index')
        },
        getLeadsActivitiesUrl() {
            return route('partners_int.views.leads.index')
        },
    }
})
